import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';

import { SearchResultTopics } from './types';

export type SearchResultTopicsAction = SearchLoadFulfilledAction | SearchLoadMoreFulfilledAction;

const initialState: SearchResultTopics = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<SearchResultTopics, SearchResultTopicsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResultTopics);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResultTopics);
    default:
      return state;
  }
};

export default reducer;
